import React from 'react';

import {LeftArrow} from "../../icons/arrows/left-arrow";
import {RightArrow} from "../../icons/arrows/right-arrow";
import {HeaderDateSelectorPickerDialog,} from "./header-date-selector.picker-dialog";
import {Link} from "../link/link";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {Type} from "../../../infrastructure/type";
import {HeaderDateSelectorComposer} from "./header-date.selector.composer";
import {Tooltip} from "../tooltip/tooltip";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../models/device.view-model";
import {AppTerms} from "../../app/app-terms";

export class HeaderDateSelectorProps extends BaseProps {
  device: DeviceViewModel;
  onDateChange: Function;
  onClickPrevious: Function;
  onClickNext: Function;
  isToday: Boolean;
  toRenderCalendar: Boolean;
  date: Date;
  endDate: Date;
  displayDate: String;
  prevTooltip: String;
  nextTooltip: String;
  arrowsContainerClassName: String;
  displayEndDate: String;
  nextLinkModel: BaseLinkModel;
  previousLinkModel: BaseLinkModel;
  linkType: Type<BaseLinkModel>;
  i18n: AppTerms;
}

export const HeaderDateSelector = HeaderDateSelectorComposer((props: HeaderDateSelectorProps) => {
  const datePickerProps = {
    controller: props.controller,
    i18n: props.controller.state.terms,
    selectedDate: props.date,
    linkType: props.linkType,
    onDateChange: props.onCalendarDateChange,
    onChange: () => {
      return true;
    },
  }

  const prevArrowLinkProps = {
    model: props.previousLinkModel,
    className: 'header-date-selector-arrow-container',
    onClick: () => {
      props.onDateChange && props.onDateChange();
      props.onClickPrevious && props.onClickPrevious();

      return true;
    }
  }

  const nextArrowLinkProps = {
    model: props.nextLinkModel,
    className: 'header-date-selector-arrow-container',
    onClick: () => {
      props.onDateChange && props.onDateChange();
      props.onClickNext && props.onClickNext();

      return true;
    }
  }

  return (
    <div className={[props.className, 'header-date-selector-container'].join(' ')}>
      <div className={[props.arrowsContainerClassName, 'header-date-selector-arrows-container'].join(' ')}>
        <Tooltip title={props.prevTooltip}>
          <Link {...prevArrowLinkProps}>
            {props.device.isRtl ? <RightArrow className={'clickable'}/> : <LeftArrow className={'clickable'}/>}
          </Link>
        </Tooltip>
        <div className={'header-date-selector-date'}>
          {props.displayDate}
        </div>
        {
          props.endDate && <>
            -
            <div className={'header-date-selector-date'}>
              {props.displayEndDate}
            </div>
          </>
        }
        <Tooltip title={props.nextTooltip}>
          <Link {...nextArrowLinkProps}>
            {!props.device.isRtl ? <RightArrow className={'clickable'}/> : <LeftArrow className={'clickable'}/>}
          </Link>
        </Tooltip>
      </div>
      {
        props.toRenderCalendar && <HeaderDateSelectorPickerDialog {...datePickerProps} />
      }
    </div>
  );
});
